import { Autocomplete, TextField } from '@mui/material';

import { useGetUsersOptions } from '../../../../common/hooks/useGetUsersOptions';
import { useNcrMyTasksContext } from '../../store/NCRMyTasksProvider';

const ResponsibleFilter = () => {
    const { responsibleFilter, setNcrMyTasksResponsibleFilter } = useNcrMyTasksContext();

    const [userOptions] = useGetUsersOptions();

    return (
        <Autocomplete
            value={responsibleFilter}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            options={userOptions}
            sx={{ minWidth: 240 }}
            getOptionLabel={option => option.fullName || ''}
            renderInput={params => <TextField {...params} label={'Responsible'} />}
            onChange={(_, data) => setNcrMyTasksResponsibleFilter(data)}
        />
    );
};

export default ResponsibleFilter;
